import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@repo/share-log-web-utils";

const labelVariants = cva(
  "text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70",
);

export interface LabelProps
  extends React.ComponentProps<"label">,
    VariantProps<typeof labelVariants> {}

function Label({ className, ...props }: LabelProps) {
  return (
    <label
      className={cn(labelVariants(), className)}
      data-slot="label"
      {...props}
    />
  );
}

export { Label };
